import React from 'react'

import {
  AppearingWrapper,
  CTAHeadline,
  SectionContainer,
} from 'Components/Blocks'
import { SubsectionTitle } from 'Components/Blocks/Titles'
import { Column } from 'Components/UI'

import {
  LANDING_CONTENT_PX,
  LANDING_SECTION_GAP,
  LANDING_SECTION_PY,
} from 'Constants/Landing'

import Roadmap from './Roadmap'

function HowItWorksSection() {
  return (
    <SectionContainer px={LANDING_CONTENT_PX}>
      <AppearingWrapper centered>
        <Column
          alignCenter
          fullWidth
          gap={LANDING_SECTION_GAP}
          py={LANDING_SECTION_PY}
        >
          <SubsectionTitle
            centered
            maxWidth={800}
            paragraph="With Emajin Golf, you’ll discover a rewarding way to connect with your peers and business colleagues that’s unlike anything else."
            subtitle="Network like never before – both on and off the golf course."
            title="How It Works"
          />

          <Roadmap />

          <CTAHeadline
            centered
            text="Great Communities are Built with Great People"
          />
        </Column>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default HowItWorksSection
